module.exports = __webpack_public_path__ + "static/img/11.8d5cd2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/11.png
// module id = /1bt
// module chunks = 0